import { lazy } from "react";
// Care Gaps (legacy). La versión canónica es care-gaps-v2, montada en
// /care-gaps. Esta queda accesible solo por URL directa para rollback rápido —
// no se expone en el sidebar.
const CareGapsPageContainer = lazy(() => import("./pages/CareGapsPageContainer"));
export const careGapsLegacyRoutes = [
  { path: "/care-gaps-legacy", element: <CareGapsPageContainer /> },
];

export default CareGapsPageContainer;
